import { render, staticRenderFns } from "./reporttips.vue?vue&type=template&id=14878160"
import script from "./reporttips.vue?vue&type=script&lang=js"
export * from "./reporttips.vue?vue&type=script&lang=js"
import style0 from "./reporttips.vue?vue&type=style&index=0&id=14878160&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports